export default __webpack_public_path__ + "static/media/error-robotmobile.9df34375.png";